/* Gudsip Contact page (sections/gudsip-contact-*.liquid): the mascot's lines (hero), the copy buttons (cards), the
   form's topic chips and order-number box, the letter counter, friendly checks before the form sends (FormSubmit, or
   Shopify), and the bulk band's button picking its topic. Every Contact section loads this file, so it runs once per
   page; clicks are handled on the document, so sections the theme editor re-draws keep working. Header, menu, cart,
   footer and scroll reveals come from assets/gudsip.js. Built from scratch/contact-build/theme/gudsip-contact.js. */
(() => {
  'use strict';
  if (window.gudsipContact) return;
  window.gudsipContact = true;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // the cart snippet's toast (layout/gudsip.liquid)
  function toast(msg) {
    const toastEl = $('.toast');
    if (!toastEl || !msg) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-show');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(() => toastEl.classList.remove('is-show'), 2600);
  }

  /* ---------- The gud block says hi (tap it for the next line) ---------- */
  document.addEventListener('click', e => {
    const buddy = e.target.closest('[data-ct-talk]');
    if (!buddy) return;
    buddy.classList.remove('is-hop'); void buddy.offsetWidth; buddy.classList.add('is-hop');
    let lines = [];
    try { lines = JSON.parse(buddy.dataset.lines).map(l => l.trim()).filter(Boolean); } catch { lines = []; }
    const bubble = $('[data-bubble]', buddy.closest('.ct-hero') || document);
    if (!bubble || lines.length < 2) return;
    const line = (Number(buddy.dataset.line || 0) + 1) % lines.length;
    buddy.dataset.line = line;
    bubble.textContent = lines[line];
    bubble.classList.remove('is-new'); void bubble.offsetWidth; bubble.classList.add('is-new');
  });

  /* ---------- Copy buttons ---------- */
  document.addEventListener('click', async e => {
    const b = e.target.closest('.ct-copy[data-copy]');
    if (!b) return;
    const holder = b.closest('[data-copied-msg]');
    try {
      await navigator.clipboard.writeText(b.dataset.copy);
      toast(holder ? holder.dataset.copiedMsg : '');
    } catch {
      toast(b.dataset.copy);
    }
  });

  /* ---------- Contact form ---------- */
  const checks = {
    name: el => el.value.trim().length > 0,
    email: el => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(el.value.trim()),
    message: el => el.value.trim().length >= 10
  };
  const mark = el => {
    const ok = checks[el.dataset.check](el);
    el.closest('.ct-field').classList.toggle('is-bad', !ok);
    el.setAttribute('aria-invalid', String(!ok));
    return ok;
  };

  function initForm(form) {
    if (form.dataset.ctReady) return;
    form.dataset.ctReady = '1';
    form.noValidate = true; // our own friendly checks replace the browser's bubbles
    const card = form.closest('[data-check-msg]');
    const view = $('[data-form-view]', form), done = $('[data-form-done]', form);
    const fields = $('[data-order-topic]', form);
    const orderTopic = fields ? fields.dataset.orderTopic : '';
    const orderField = $('[data-order-field]', form);
    const topics = $$('input[data-topic]', form);
    const msg = $('[data-check="message"]', form), countOut = $('[data-count-out]', form);
    // the order number box only shows for the order topic (always, when no topic is set)
    const syncTopic = () => {
      const chosen = (topics.find(r => r.checked) || {}).value;
      if (orderField) orderField.hidden = !!orderTopic && !!topics.length && chosen !== orderTopic;
    };
    topics.forEach(r => r.addEventListener('change', syncTopic));
    syncTopic();
    const count = () => { if (msg && countOut) countOut.textContent = `${msg.value.length} / ${msg.maxLength}`; };
    if (msg) { msg.addEventListener('input', count); count(); }

    const checked = $$('[data-check]', form);
    // once a field has been flagged, the flag clears as soon as it's fixed
    checked.forEach(el => el.addEventListener('input', () => { if (el.closest('.ct-field').classList.contains('is-bad')) mark(el); }));

    // "Send messages to" (section setting): FormSubmit emails the message to that address. Its first message only asks
    // the address to click "Activate form"; that reply isn't a success, so the message also goes to Shopify (below).
    const sendTo = fields ? fields.dataset.sendTo || '' : '';
    const value = name => { const el = form.elements[name]; return el ? String(el.value || '').trim() : ''; };
    async function sendWithFormsubmit() {
      const topic = value('contact[Topic]');
      const data = {
        Name: value('contact[name]'), Email: value('contact[email]'), Phone: value('contact[phone]'), Topic: topic,
        'Order number': value('contact[Order number]'), Message: value('contact[body]'), Page: location.href
      };
      Object.keys(data).forEach(k => { if (!data[k]) delete data[k]; });
      // every subject differs (name + a short reference): Gmail stacks emails with the same subject into one
      // conversation, so with one fixed subject new messages looked like they never came
      const ref = Date.now().toString(36).slice(-5).toUpperCase();
      // FormSubmit's own fields (not shown in the email): reply goes to the customer, a clear subject, a tidy table
      Object.assign(data, { _replyto: data.Email, _subject: `New message from ${data.Name}${topic ? ` (${topic})` : ''}: Gudsip website #${ref}`, _template: 'table' });
      // a FormSubmit that hangs counts as failed, so the message still goes to Shopify
      const stop = new AbortController();
      const timer = setTimeout(() => stop.abort(), 20000);
      try {
        const res = await fetch(`https://formsubmit.co/ajax/${encodeURI(sendTo)}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(data),
          signal: stop.signal
        });
        const out = await res.json().catch(() => ({}));
        if (!res.ok || String(out.success) !== 'true') throw Error(`FormSubmit ${res.status}: ${out.message || ''}`);
      } finally {
        clearTimeout(timer);
      }
    }
    // Shopify's spam check (hCaptcha) swaps in its own form.submit that adds its token first; without that token
    // Shopify sends the customer to a captcha page instead
    const sendWithShopify = () => (typeof form.submit === 'function' ? form.submit() : HTMLFormElement.prototype.submit.call(form));

    const submit = $('[type="submit"]', form);
    let sending = false;
    // capture phase, so this runs before Shopify's hCaptcha submit listener. That listener posts the form to Shopify
    // (reloading the page) while FormSubmit was still sending, which cut some messages off; it now only runs when the
    // message is meant for Shopify.
    form.addEventListener('submit', e => {
      const bad = checked.filter(el => !mark(el));
      if (bad.length) {
        e.preventDefault();
        e.stopImmediatePropagation();
        bad[0].focus();
        toast(card ? card.dataset.checkMsg : '');
        return;
      }
      submit.setAttribute('aria-busy', 'true');
      if (!sendTo) return; // off to Shopify
      e.preventDefault();
      e.stopImmediatePropagation();
      if (sending) return;
      sending = true;
      sendWithFormsubmit().then(() => {
        sending = false;
        submit.removeAttribute('aria-busy');
        view.hidden = true;
        done.hidden = false;
        done.focus();
      }).catch(err => {
        // FormSubmit didn't take it (not activated yet, offline…): post to Shopify so the message isn't lost
        console.warn('Gudsip contact: FormSubmit failed, sending with Shopify instead.', err);
        sendWithShopify();
      });
    }, true);

    // after sending: the thank-you card is shown; "send another" brings the empty form back
    const again = $('[data-form-again]', form);
    if (again) again.addEventListener('click', () => {
      form.reset();
      checked.forEach(el => { el.value = ''; el.closest('.ct-field').classList.remove('is-bad'); });
      syncTopic();
      count();
      done.hidden = true;
      view.hidden = false;
      checked[0].focus();
    });
    if (done && !done.hidden) setTimeout(() => done.focus({ preventScroll: true }), 300);
    const alert = $('.ct-alert', form);
    if (alert) setTimeout(() => alert.focus(), 300);
  }
  const initForms = (root = document) => $$('form.ct-formwrap', root).forEach(initForm);
  initForms();
  document.addEventListener('shopify:section:load', e => initForms(e.target));

  // the bulk band's "Ask about bulk orders" picks that topic in the form before jumping to it
  document.addEventListener('click', e => {
    const a = e.target.closest('[data-pick-topic]');
    const form = a && $('form.ct-formwrap');
    if (!form) return;
    const radio = $$('input[data-topic]', form).find(r => r.value === a.dataset.pickTopic);
    if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
    const view = $('[data-form-view]', form), msg = $('[data-check="message"]', form);
    if (view && !view.hidden && msg) setTimeout(() => msg.focus({ preventScroll: true }), reduce ? 0 : 900);
  });
})();
